import { capAmount } from '@homestake/shared/utils';
import { observable } from '@legendapp/state';
import { configurationState$ } from './configuration.state';

type ManualBetState = {
  betAmount: number;
  isBetting: boolean;
  setBetAmount: (betAmount: number) => void;
  incrementBetAmount: () => void;
  decrementBetAmount: () => void;
  setIsBetting: (isBetting: boolean) => void;
};

export const manualBetState$ = observable<ManualBetState>({
  betAmount: 0,
  isBetting: false,
  setBetAmount: (betAmount: number) => {
    // Validate input
    if (
      Number.isNaN(betAmount) ||
      !Number.isFinite(betAmount) ||
      betAmount < 0
    ) {
      betAmount = 0;
    }
    const maxBetAmount = configurationState$.maxBet.peek();
    const minBetAmount = configurationState$.minBet.peek();
    const cappedBetAmount = Math.min(
      Math.max(betAmount, minBetAmount),
      maxBetAmount
    );

    manualBetState$.betAmount.set(cappedBetAmount);
  },
  incrementBetAmount: () => {
    const betStepAmount = configurationState$.betStepAmount.peek();
    const minBet = configurationState$.minBet.peek();
    const maxBet = configurationState$.maxBet.peek();
    manualBetState$.betAmount.set((prev) => {
      const cappedBetAmount = capAmount({
        amount: prev + betStepAmount,
        min: minBet,
        max: maxBet,
      });
      return cappedBetAmount;
    });
  },
  decrementBetAmount: () => {
    const betStepAmount = configurationState$.betStepAmount.peek();
    const minBet = configurationState$.minBet.peek();
    const maxBet = configurationState$.maxBet.peek();
    manualBetState$.betAmount.set((prev) => {
      const cappedBetAmount = capAmount({
        amount: prev - betStepAmount,
        min: minBet,
        max: maxBet,
      });
      return cappedBetAmount;
    });
  },
  setIsBetting: (isBetting: boolean) => {
    manualBetState$.isBetting.set(isBetting);
  },
});
